import { createSelector, createSlice, PayloadAction } from '@reduxjs/toolkit';
import { RootState } from 'app/store';
import { employeesApi, GetEmployeesResponse, TEmploee } from 'app/services/edpApiV1/employees';

export type TEmployees = {
  data: TEmploee[];
};

const initialState: TEmployees = {
  data: [
    {
      id: 0,
      name: '',
      lastName: '',
      middleName: '',
      image: '',
      division: {
        divisionId: '',
        name: '',
      },
      personnelNumber: '',
      temporaryPassword: '',
    },
  ],
};

export const employeesSlice = createSlice({
  name: 'employees',
  initialState,
  reducers: {},
  extraReducers: builder => {
    builder
      .addMatcher(
        employeesApi.endpoints.getEmployees.matchFulfilled,
        (state, { payload }: PayloadAction<GetEmployeesResponse>) => payload,
      )
      .addMatcher(employeesApi.endpoints.getEmployees.matchRejected, () => initialState);
  },
});

const employees = (state: RootState) => state.entities.employees;
const getEmployees = createSelector(employees, state => state);

export const selectors = { getEmployees };
export const actions = employeesSlice.actions;
export const reducer = employeesSlice.reducer;
